const stringExtension = (joi) => ({
    type: 'string',
    base: joi.string(),
    messages: {
        startsWith: '{{#label}} needs to start with specified string "{{#str}}".',
        endsWith: '{{#label}} needs to end with specified string "{{#str}}".',
        maxWordCountSingular: '{{#label}} cannot have more than {{#count}} word.',
        maxWordCountPlural: '{{#label}} cannot have more than {{#count}} word.',
        minWordCountSingular: '{{#label}} must have at least {{#count}} word.',
        minWordCountPlural: '{{#label}} must have at least {{#count}} words.',
    },
    rules: {
        startsWith: {
            alias: 'beginsWith',
            method(argument) {
                return this.$_addRule({ name: 'startsWith', args: { argument } });
            },
            args: [
                {
                    name: 'argument',
                    ref: true,
                    assert: (value) => !!(typeof value === 'string' && value.length),
                    message: 'must be a string with at least 1 character',
                },
            ],
            validate(value, helpers, args) {
                if (!value.startsWith(args.argument)) {
                    return helpers.error('startsWith', { str: args.argument });
                }
                return value;
            },
        },
        endsWith: {
            method(argument) {
                return this.$_addRule({ name: 'endsWith', args: { argument } });
            },
            args: [
                {
                    name: 'argument',
                    ref: true,
                    assert: (value) => !!(typeof value === 'string' && value.length),
                    message: 'must be a string with at least 1 character',
                },
            ],
            validate(value, helpers, args) {
                if (!value.endsWith(args.argument)) {
                    return helpers.error('endsWith', { str: args.argument });
                }
                return value;
            },
        },
        maxWordCount: {
            method(argument) {
                return this.$_addRule({ name: 'maxWordCount', args: { argument } });
            },
            args: [
                {
                    name: 'argument',
                    ref: true,
                    assert: (value) => typeof value === 'number' && value >= 0,
                    message: 'must be a number greater than or equal to zero',
                },
            ],
            validate(value, helpers, args) {
                if (value.trim().split(' ').filter((n) => n !== '').length > args.argument) {
                    return helpers.error(args.argument === 1 ? 'maxWordCountSingular' : 'maxWordCountPlural', { count: args.argument });
                }
                return value;
            },
        },
        minWordCount: {
            method(argument) {
                return this.$_addRule({ name: 'minWordCount', args: { argument } });
            },
            args: [
                {
                    name: 'argument',
                    ref: true,
                    assert: (value) => typeof value === 'number' && value >= 0,
                    message: 'must be a number greater than or equal to zero',
                },
            ],
            validate(value, helpers, args) {
                if (value.trim().split(' ').filter((n) => n !== '').length < args.argument) {
                    return helpers.error(args.argument === 1 ? 'minWordCountSingular' : 'minWordCountPlural', { count: args.argument });
                }
                return value;
            },
        },
    },
});
function getAge(date) {
    const today = new Date();
    const birthDate = Object.prototype.toString.call(date) === '[object Date]' ? date : new Date(date);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age -= 1;
    }
    return age;
}
const dateExtensions = (joi) => ({
    type: 'date',
    base: joi.date(),
    messages: {
        minAge: '{{#label}} needs to be at least {{#years}} years ago.',
        maxAge: '{{#label}} cannot be more than {{#years}} years ago.',
    },
    rules: {
        minAge: {
            method(argument) {
                return this.$_addRule({ name: 'minAge', args: { argument } });
            },
            args: [
                {
                    name: 'argument',
                    ref: true,
                    assert: (value) => typeof value === 'number' && value >= 0,
                    message: 'must be a number greater than or equal to zero',
                },
            ],
            validate(value, helpers, args) {
                const age = getAge(value);
                if (age < args.argument) {
                    return helpers.error('minAge', { years: args.argument });
                }
                return value;
            },
        },
        maxAge: {
            method(argument) {
                return this.$_addRule({ name: 'maxAge', args: { argument } });
            },
            args: [
                {
                    name: 'argument',
                    ref: true,
                    assert: (value) => typeof value === 'number' && value >= 0,
                    message: 'must be a number greater than or equal to zero',
                },
            ],
            validate(value, helpers, args) {
                const age = getAge(value);
                if (age > args.argument) {
                    return helpers.error('maxAge', { years: args.argument });
                }
                return value;
            },
        },
    },
});
const arrayExtension = (joi) => ({
    type: 'array',
    base: joi.array(),
    messages: {
        includes: '{{#label}} needs to include at least 1 match to schema.',
    },
    rules: {
        includes: {
            alias: 'findOne',
            method(...allArgs) {
                return this.$_addRule({ name: 'includes', args: { allArgs } });
            },
            args: [
                {
                    name: 'allArgs',
                    ref: true,
                    assert: (value) => value.every((el) => joi.isSchema(el)),
                    message: 'arguments must be valid schemas',
                },
            ],
            validate(value, helpers, args) {
                const { allArgs } = args;
                if (!allArgs?.every((arg) => value.find((el) => !arg.validate(el).error))) {
                    return helpers.error('includes', { str: args.argument });
                }
                return value;
            },
        },
    },
});
export { stringExtension, dateExtensions, arrayExtension, };
